import Marquee from "react-fast-marquee";

const items = [
  "Cocktails créatifs",
  "Buffets sur-mesure",
  "Plateaux-repas",
  "Brasero & Paella",
  "Mariages",
  "Séminaires",
  "Produits du terroir",
  "Fait maison",
];

export default function EditorialMarquee({ dark = false }) {
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-6 ${dark ? "border-[#3d2c26] bg-[#2A1D1A]" : "border-[#E8E2D9] bg-[#F2EBE1]"}`}
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {items.map((item) => (
          <span key={item} className="mx-10 flex items-center gap-10">
            <span className={`font-serif-display text-2xl italic md:text-3xl ${dark ? "text-[#CBA135]" : "text-[#7A6B63]"}`}>
              {item}
            </span>
            <span className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-[#C05A45]" : "bg-[#CBA135]"}`} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
